import { GenreGroupMenuBookInfoType, IMenu, SubgenreDataType } from 'apis/types';
import { DisplayTimingGroupResults } from 'utils/displayTimingGroup';
import { isSubgenreVisibleInGenre } from 'utils/isSubgenreVisibleInGenre';

export function composeFaireData(
  genre: GenreGroupMenuBookInfoType[],
  subGenre: SubgenreDataType,
  menuData?: IMenu,
  shinagire: string[] = [],
  displayTimingGroupResults: DisplayTimingGroupResults = {}
): { genreId: string; subgenreId: string }[] {
  const faireList: { genreId: string; subgenreId: string }[] = [];

  if (genre) {
    genre?.forEach((genreData) => {
      genreData.subgenre.forEach((subGen) => {
        const subGenreData = subGenre[subGen.subgenre_id];
        const faireData = subGenreData?.faire;
        // A banner scrolls to `#subgenre-menu-${subgenreId}`, so it is only useful
        // while that subgenre still renders at least one menu item.
        if (
          faireData &&
          faireData.faire_flg === '1' &&
          isSubgenreVisibleInGenre(subGen.subgenre_id, genreData, menuData, shinagire, displayTimingGroupResults)
        ) {
          faireList.push({ genreId: genreData.genre_id, subgenreId: subGen.subgenre_id });
        }
      });
    });
  }
  return faireList;
}
